<page-title text="Support | BitOasis" i18n-text="@@pageTitle.support"></page-title>
<site-layout class="push narrow">
  <h2 class="text-header text-bold text-center text-dark mb-2" i18n="@@front.support.title">Submit a Support Ticket</h2>
  <p class="text-lg text-center" i18n="@@front.support.subtitle">How can we help you?</p>
  <div class="p-3"></div>

  <page-notification location="SUPPORT"></page-notification>
  <support-form [type]="type"></support-form>

  <p class="m-3 text-center" i18n="@@front.support.knowledgeCenter">Do you have questions? Check our <a href="https://support.bitoasis.net/{{lang}}/support/home">knowledge center</a></p>

  <!-- <ng-container *ngIf="vip">
    <h3 class="text-lg text-center pt-4" i18n="@@front.support.vipSupportCardTitle">For any additional help</h3>
    <contact-card></contact-card>
  </ng-container> -->
</site-layout>
<site-footer></site-footer>